import styled, { css } from "react-emotion";
import { Burger, Menu } from "components";
import Button from "@material-ui/core/Button";
import LoginSignup from "../pages/Authentication/LoginSignup";
import { isMobileDevice } from "helpers";
import React from "react";
import MenuDropdown from "./MenuDropdown";

const buttonStyle = css`
  background-color: rgb(235, 255, 255);
  font-family: "Lucida Grande", "Lucida Sans Unicode", "Lucida Sans", Geneva,
    Verdana, sans-serif;
  font-size: 0.9375rem;
  font-weight: bold;
  font-style: normal;
  font-stretch: normal;
  line-height: normal;
  letter-spacing: normal;
  text-transform: none;
  width: auto;
`;

const menuSpanStyle = css`
  text-transform: none;
`;

const AButton = styled("a")`
  text-decoration: none;
  display: inline-block;
  letter-spacing: 0.03rem;
  border-bottom: ${(props) =>
    props.isSelected ? "1px solid #89d2d3" : "none"};
  &:hover {
    border-bottom: 1px solid #465362;
  }
`;

const menuItemsBarStyle = css`
  display: none;
  font-size: 0.9375rem;
  @media only screen and (min-width: 768px) {
    display: inline-block !important;
  }
`;

const loginStyle = css`
  display: none;
  font-size: 0.9375rem;
  @media only screen and (min-width: 768px) {
    display: inline-block !important;
  }
`;

const isMob = isMobileDevice();
class MenuToggler extends React.Component {
  state = {
    open: false,
  };

  toggleMenu = (e) => {
    let { open } = this.state;
    open = !open;
    this.setState({ open });
  };
  render() {
    let { open } = this.state;
    const goToHome = () =>
      this.props.history.push({
        pathname: "/",
      });
    const goToMarketPlace = () =>
      this.props.history.push({
        pathname: "/marketplace",
      });
    const goToPricing = () =>
      this.props.history.push({
        pathname: "/pricing",
      });
    const goToContact = () =>
      this.props.history.push({
        pathname: "/contact",
      });
    const goToPartners = () =>
      this.props.history.push({
        pathname: "/partners",
      });
    const goToTutorials = () =>
      this.props.history.push({
        pathname: "/tutorials",
      });
    const goToFAQs = () =>
      this.props.history.push({
        pathname: "/faqs",
      });
    const goToOurStory = () =>
      this.props.history.push({
        pathname: "/ourstory",
      });
    const goToNewsletters = () =>
      this.props.history.push({
        pathname: "/newsletters",
      });

    const goToHowItWorks = () => {
      this.props.history.push({ pathname: "/how-it-works" });
    };
    const goToOurMission = () => {
      this.props.history.push({ pathname: "/our-mission" });
    };
    const goToSupportSmall = () => {
      this.props.history.push({ pathname: "/support-small-business" });
    };

    const menuOptions = [
      { listText: "Home", listFunc: goToHome },
      { listText: "Marketplace", listFunc: goToMarketPlace },
      { listText: "Our Story", listFunc: goToOurStory },
      { listText: "Pricing", listFunc: goToPricing },
      { listText: "Partnerships", listFunc: goToPartners },
      { listText: "FAQs", listFunc: goToFAQs },
      { listText: "Newsletters", listFunc: goToNewsletters },
      { listText: "Contact", listFunc: goToContact },
      { listText: "Tutorials", listFunc: goToTutorials },
    ];

    const ForBusinessesOptions = [
      { listText: "How It Works", listFunc: goToHowItWorks },
      { listText: "Pricing", listFunc: goToPricing },
      { listText: "Partnerships", listFunc: goToPartners },
      { listText: "Tutorials", listFunc: goToTutorials },
    ];

    const ForConsumersOptions = [
      { listText: "Support Small Businesses", listFunc: goToSupportSmall },
      { listText: "Marketplace", listFunc: goToMarketPlace },
    ];

    const AboutOptions = [
      { listText: "Our Mission", listFunc: goToOurMission },
      { listText: "Our Story", listFunc: goToOurStory },
      { listText: "FAQs", listFunc: goToFAQs },
      { listText: "Contact", listFunc: goToContact },
    ];

    if (isMob) {
      return (
        <div style={{ width: "32px" }}>
          <Burger open={open} setOpen={this.toggleMenu} />
          <Menu
            open={open}
            setOpen={this.toggleMenu}
            menuOptions={menuOptions}
          />
        </div>
      );
    } else {
      let path = null;
      if (this.props.history.location) {
        path = this.props.history.location.pathname;
      }
      return (
        <div>
          <div className={menuItemsBarStyle}>
            <MenuDropdown
              title={"For Businesses"}
              options={ForBusinessesOptions}
            />
            <MenuDropdown
              title={"For Consumers"}
              options={ForConsumersOptions}
            />
            <MenuDropdown title={"About"} options={AboutOptions} />
          </div>
          {/* <div className={menuItemsBarStyle}>
            <AButton
              onClick={goToMarketPlace}
              isSelected={path === "/marketplace"}
            >
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/marketplace" ? "black" : "#465362",
                  }}
                >
                  Marketplace
                </span>
              </Button>
            </AButton>
            <AButton onClick={goToOurStory} isSelected={path === "/ourstory"}>
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/ourstory" ? "black" : "#465362",
                  }}
                >
                  Our Story
                </span>
              </Button>
            </AButton>
            <AButton onClick={goToPricing} isSelected={path === "/pricing"}>
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/pricing" ? "black" : "#465362",
                  }}
                >
                  Pricing
                </span>
              </Button>
            </AButton>

            <AButton onClick={goToPartners} isSelected={path === "/partners"}>
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/partners" ? "black" : "#465362",
                  }}
                >
                  Partnerships
                </span>
              </Button>
            </AButton>

            <AButton onClick={goToFAQs} isSelected={path === "/faqs"}>
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/faqs" ? "black" : "#465362",
                  }}
                >
                  FAQs
                </span>
              </Button>
            </AButton>
            <AButton onClick={goToTutorials} isSelected={path === "/tutorials"}>
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/tutorials" ? "black" : "#465362",
                  }}
                >
                  Tutorials
                </span>
              </Button>
            </AButton>
            <AButton
              onClick={goToNewsletters}
              isSelected={path === "/newsletters"}
            >
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/newsletters" ? "black" : "#465362",
                  }}
                >
                  Newsletters
                </span>
              </Button>
            </AButton>
            <AButton onClick={goToContact} isSelected={path === "/contact"}>
              <Button className={buttonStyle} color="secondary">
                <span
                  className={menuSpanStyle}
                  style={{
                    color: path === "/contact" ? "black" : "#465362",
                  }}
                >
                  Contact
                </span>
              </Button>
            </AButton>
          </div> */}
          {/* <div onClick={this.toggleMenu} className={menuIcon}>
            {open ? (
              <WebIcon
                iconName={"cancel"}
                useColor={true}
                size={"20px"}
                hover={true}
              />
            ) : (
              <WebIcon
                iconName={"burger"}
                useColor={true}
                size={"20px"}
                hover={true}
              />
            )}
          </div> */}
          <div className={loginStyle}>
            <LoginSignup split={true} />
          </div>
        </div>
      );
    }
  }
}

export default MenuToggler;
